import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { PrimaryBtn } from '../../Components/Buttons/styles'
import { BROADCASTER_LINKS } from '../../Config/config'
import { DraftCallout } from './styles'

export const Callout: React.FC<React.PropsWithChildren<unknown>> = () => {
  const startingText = `The College Draft is starting soon. Watch on ESPNU & ESPN+`
  const liveText = `The College Draft is LIVE. Watch on ESPNU & ESPN+`
  const [text, setText] = useState<string>('')
  const [showCallout, setShowCallout] = useState<boolean>(false)

  useEffect(() => {
    checkDraftStatus()
    const interval = setInterval(() => {
      //Starting interval to go every 30 seconds
      let shouldContinueTimer = checkDraftStatus()
      if (!shouldContinueTimer) {
        clearInterval(interval)
        return
      }
    }, 20000)
    return () => clearInterval(interval)
  }, [])

  const checkDraftStatus = () => {
    //Checking draft status
    const draftStart = 1652227200
    const draftLength = 5400
    let now = Date.now() / 1000
    const diff = draftStart - now
    if (diff > 1800) {
      //More than 30 mins till draft
      return true
    }
    if (diff > 0) {
      // Hasn't started yet
      if (diff <= 1800 && diff >= 600) {
        //Within 30 mins, but more than 10 mins
        setText(startingText)
        setShowCallout(true)
        return true
      } else {
        setText(liveText)
        setShowCallout(true)
        return true
      }
    } else {
      const timeAfterDraftStart = draftLength + diff //diff is negative
      if (timeAfterDraftStart < 0) {
        //Ended
        setText('')
        setShowCallout(false)
        return false
      } else {
        setText(liveText)
        setShowCallout(true)
        return true
      }
    }
  }

  if (!showCallout) {
    return <div />
  }

  return (
    <DraftCallout>
      <div className=".inner">
        <div className="calloutOptionRow">
          <div className="calloutInfoCol">
            <div className="title">{text}</div>
          </div>
          <div className="calloutInfoCol">
            <Link to={BROADCASTER_LINKS.collegeDraft}>
              <PrimaryBtn buttonType={'primary'}>Watch Live</PrimaryBtn>
            </Link>
          </div>
        </div>
      </div>
    </DraftCallout>
  )
}
